import App from './App'
import router from './router'
import store from './store/'
import Vue from './util/usePlugin'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

process.env.NODE_ENV === 'production' && Sentry.init({
  Vue,
  dsn: 'https' === document.location.protocol ? "https://9d577796614548ae8246b60c5eeed9bf@sentry.card900.com:9000/12" : "http://9d577796614548ae8246b60c5eeed9bf@8.135.47.109:9000/12",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "sim.car900.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  logErrors: true
});


Vue.config.productionTip = false
Vue.prototype.$url = ''

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})
